import Vue from "vue";
import VueI18n from "vue-i18n";
import enUS from "@/locale/en-US";
import frCA from "@/locale/fr-CA";
import frQC from "@/locale/fr-QC";
import { merge } from "lodash";

Vue.use(VueI18n);

function loadCustomMessages() {
  const locales = require.context(
    `../configs/${process.env.VUE_APP_CONFIG}/locale/`,
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  // eslint-disable-next-line
  const messages: any = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const messages = {
  "en-US": { ...enUS },
  "fr-CA": { ...frCA },
  "fr-QC": { ...frQC },
};

const options = {
  locale: "en-CA", // set locale
  messages: merge(messages, loadCustomMessages()), // set locale messages
  silentFallbackWarn: true,
};

// Create VueI18n instance with options
export default new VueI18n(options);
